import { render, staticRenderFns } from "./IxSlider.vue?vue&type=template&id=6a13dae0&scoped=true&lang=html&"
import script from "./IxSlider.vue?vue&type=script&lang=js&"
export * from "./IxSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a13dae0",
  null
  
)

export default component.exports